import axios from 'axios';

/** The backend's explanation of a failed request (FastAPI's `detail`), otherwise the transport error. */
export const apiErrorMessage = (error: unknown) => {
  if (!axios.isAxiosError(error)) return String(error);
  const data = error.response?.data as { detail?: unknown } | undefined;

  return typeof data?.detail === 'string' ? data.detail : error.message;
};
